import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {RankingsSlider} from "./rankings_slider";

export const rankingsSliderLoader = function (options = {}) {
    componentLoader(componentConfig(RankingsSlider, RankingsSlider.config.componentTypeKey, RankingsSlider.config.baseHtmlClass), options);
};
